import { Divider, Tag } from 'antd'
import React, { useEffect } from 'react'
import Input from '../../components/UI/Input'
import SwitchInput from '../../components/UI/SwitchInput'
import { IConfigPageProps } from './types'
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";

export const switchOptions = {
  check: 'true',
  uncheck: 'false',
}

function System(props: IConfigPageProps) {
  const {canEdit} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'system'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])
  
  return (
    <div className="config-system"> 
      <div className="config-system__row config-system__row--title">
          <h3>Email Server Configuration</h3>
          <p>It's the email server the system will use when sending an email</p>
      </div>
      <div className="config-system__row config-system__row--flex-wrap">
        <Input
          label="Email SMTP server host"
          onChange={(e: any) => props.setConfig(e.target.value, 'EMAIL_SMTP_SERVER_HOST')}
          value={props.config.EMAIL_SMTP_SERVER_HOST}
          disabled={!canEdit}
        />
        <Input
          label="Email server user"
          onChange={(e: any) => props.setConfig(e.target.value, 'EMAIL_SERVER_USER_LOGIN')}
          value={props.config.EMAIL_SERVER_USER_LOGIN}
          disabled={!canEdit}
        />
        <Input
          label="Email server password"
          onChange={(e: any) => props.setConfig(e.target.value, 'EMAIL_SERVER_USER_PASSWORD')}
          value={props.config.EMAIL_SERVER_USER_PASSWORD}
          type="password"
          disabled={!canEdit}
        />
      </div>
    </div>
  )
}

export default System